import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from "@react-google-maps/api";
import { Card, Row, Col, Modal, Button } from "react-bootstrap";
import { useTheme, Typography, Chip, Badge } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import moment from "moment";
import "moment/locale/th"; // ต้อง import locale ภาษาไทยด้วย
// MUI Date Picker
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { DayCalendarSkeleton } from "@mui/x-date-pickers/DayCalendarSkeleton";
import { use } from "react";
import { getAllAppointment } from "../../../redux/handlers/report/getAllAppointment.handler";
moment.locale("th");
function ServerDay(props) {
    var _props_highlightedDays = props.highlightedDays, highlightedDays = _props_highlightedDays === void 0 ? [] : _props_highlightedDays, day = props.day, outsideCurrentMonth = props.outsideCurrentMonth, other = _object_without_properties(props, [
        "highlightedDays",
        "day",
        "outsideCurrentMonth"
    ]);
    var isSelected = !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;
    if (isSelected) {
        return /*#__PURE__*/ _jsx(Badge, {
            overlap: "circular",
            color: "error",
            variant: "dot",
            sx: {
                "& .MuiBadge-dot": {
                    height: 8,
                    minWidth: 8
                }
            },
            children: /*#__PURE__*/ _jsx(PickersDay, _object_spread_props(_object_spread({}, other), {
                outsideCurrentMonth: outsideCurrentMonth,
                day: day
            }))
        }, props.day.toString());
    } else {
        return /*#__PURE__*/ _jsx(PickersDay, _object_spread_props(_object_spread({}, other), {
            outsideCurrentMonth: outsideCurrentMonth,
            day: day
        }));
    }
}
export function ReportAppointment() {
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(dayjs()), 2), selectDate = _useState[0], setSelectDate = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), selectMonthChange = _useState1[0], setSelectMonthChange = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), highlightedDays = _useState2[0], setHighlightedDays = _useState2[1];
    var _useState3 = _sliced_to_array(useState({}), 2), visitLists = _useState3[0], setVisitLists = _useState3[1];
    var getAllAppointmentReducer = useAppSelector(function(state) {
        return state.getAllAppointmentReducer;
    });
    useEffect(function() {
        if (selectMonthChange) {
            var isMonth = selectDate.format("01/MM/YYYY");
            console.log("isMonth: ", isMonth);
            setVisitLists({});
            dispatch(getAllAppointment({
                ismonth: isMonth
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setSelectMonthChange(false);
        }
    }, [
        selectMonthChange
    ]);
    useEffect(function() {
        setIsLoading(getAllAppointmentReducer.isFetching);
        if (getAllAppointmentReducer.data && !getAllAppointmentReducer.isError) {
            var _getAllAppointmentReducer_data;
            var data = (_getAllAppointmentReducer_data = getAllAppointmentReducer.data) === null || _getAllAppointmentReducer_data === void 0 ? void 0 : _getAllAppointmentReducer_data.data;
            var highlight = data === null || data === void 0 ? void 0 : data.map(function(item) {
                return moment(item.date).date();
            });
            setHighlightedDays(highlight);
            setVisitLists(data);
        }
    }, [
        getAllAppointmentReducer
    ]);
    useEffect(function() {
        // console.log("Selected Date: ", selectDate);
        var isFocus = selectDate.format("YYYY-MM-DD");
        var element = document.getElementById(isFocus);
        if (element) {
            element.focus(); // ต้องใส่ tabIndex ด้วย
        }
    }, [
        selectDate
    ]);
    var handleMonthChange = function(date) {
        setSelectDate(date);
        setSelectMonthChange(true);
        setHighlightedDays([]);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ปฏิทินเยี่ยมร้านค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "ปฏิทินเยี่ยมร้านค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        md: 12,
                        lg: 5,
                        xl: 4,
                        className: "justify-content-center",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "mb-3",
                            style: {
                                background: "var(--light-background-paper, #fff)",
                                border: "0",
                                borderRadius: "10px",
                                boxShadow: "0 2px 10px 0 #4c4e6438"
                            },
                            children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                dateAdapter: AdapterDayjs,
                                children: /*#__PURE__*/ _jsx(DateCalendar, {
                                    value: selectDate,
                                    onChange: function(newValue) {
                                        return setSelectDate(dayjs(newValue));
                                    },
                                    loading: isloading,
                                    onMonthChange: handleMonthChange,
                                    renderLoading: function() {
                                        return /*#__PURE__*/ _jsx(DayCalendarSkeleton, {});
                                    },
                                    slots: {
                                        day: ServerDay
                                    },
                                    slotProps: {
                                        day: {
                                            highlightedDays: highlightedDays
                                        }
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Col, {
                        xs: 12,
                        md: 12,
                        lg: 7,
                        xl: 8,
                        children: [
                            visitLists && visitLists.length > 0 && visitLists.map(function(groupDay) {
                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsxs("h5", {
                                            className: "h5 mb-2",
                                            id: groupDay.date,
                                            tabIndex: -1,
                                            children: [
                                                "วันที่ ",
                                                moment(groupDay.date).format("D MMMM YYYY")
                                            ]
                                        }),
                                        groupDay.visits && groupDay.visits.length > 0 && groupDay.visits.map(function(visits) {
                                            return /*#__PURE__*/ _jsx(_Fragment, {
                                                children: /*#__PURE__*/ _jsxs(Card, {
                                                    className: "mb-2",
                                                    onClick: function() {
                                                        return navigate("/shopvisit/manage/" + visits.vs_visit_id + "/view");
                                                    },
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Card.Header, {
                                                            className: "d-flex justify-content-between align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            style: {
                                                                                color: "blue"
                                                                            },
                                                                            children: "ใบเยี่ยมชมร้านค้า"
                                                                        }),
                                                                        " #",
                                                                        visits.vs_visit_code
                                                                    ]
                                                                }),
                                                                visits.vs_visit_status == 4 && /*#__PURE__*/ _jsx(Chip, {
                                                                    label: "เลื่อนวันนัด",
                                                                    style: {
                                                                        color: "rgb(224, 13, 235)",
                                                                        backgroundColor: "rgb(248, 193, 249)"
                                                                    }
                                                                }),
                                                                visits.vs_visit_status == 3 && /*#__PURE__*/ _jsx(Chip, {
                                                                    label: "ยกเลิก",
                                                                    color: "error"
                                                                }),
                                                                visits.vs_visit_status == 2 && /*#__PURE__*/ _jsx(Chip, {
                                                                    label: "เยี่ยมชมแล้ว",
                                                                    color: "success"
                                                                }),
                                                                visits.vs_visit_status == 1 && /*#__PURE__*/ _jsx(Chip, {
                                                                    label: "นัดหมาย",
                                                                    color: "warning"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Card.Body, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("b", {
                                                                    children: /*#__PURE__*/ _jsxs("h5", {
                                                                        className: "h5 mb-2",
                                                                        style: {
                                                                            color: "darkblue"
                                                                        },
                                                                        children: [
                                                                            "ร้าน",
                                                                            visits.vs_visit_shopname,
                                                                            " สาขา ",
                                                                            visits.vs_visit_branchname
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsxs(Row, {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Col, {
                                                                            xs: 12,
                                                                            md: 12,
                                                                            lg: 8,
                                                                            xl: 8,
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(AccountCircleIcon, {}),
                                                                                        " ",
                                                                                        /*#__PURE__*/ _jsx("b", {
                                                                                            className: "mr-1",
                                                                                            children: "ชื่อผู้ดูแล :"
                                                                                        }),
                                                                                        !visits.vs_visit_salename || visits.vs_visit_salename == null || visits.vs_visit_salename == "" || visits.vs_visit_salename == undefined && "-",
                                                                                        isMobile ? /*#__PURE__*/ _jsx("br", {}) : " ",
                                                                                        visits.vs_visit_salename
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(AssignmentIcon, {}),
                                                                                        " ",
                                                                                        /*#__PURE__*/ _jsx("b", {
                                                                                            className: "mr-1",
                                                                                            children: "วัตถุประสงค์ :"
                                                                                        }),
                                                                                        !visits.VsObjective || visits.VsObjective.length == 0 && "-",
                                                                                        isMobile ? /*#__PURE__*/ _jsx("br", {}) : " ",
                                                                                        visits.VsObjective && visits.VsObjective.length > 0 && /*#__PURE__*/ _jsx(_Fragment, {
                                                                                            children: visits.VsObjective.map(function(vs) {
                                                                                                return vs.vs_objective_name;
                                                                                            }).join(", ")
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs(Col, {
                                                                            xs: 12,
                                                                            md: 12,
                                                                            lg: 4,
                                                                            xl: 4,
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("b", {
                                                                                    children: "วันที่นัดหมาย : "
                                                                                }),
                                                                                isMobile ? /*#__PURE__*/ _jsx("br", {}) : " ",
                                                                                moment.parseZone(visits.vs_visit_appointmentdate).format("D MMMM YYYY HH:mm"),
                                                                                /*#__PURE__*/ _jsx("br", {}),
                                                                                /*#__PURE__*/ _jsx("b", {
                                                                                    children: "วันที่เข้าพบ : "
                                                                                }),
                                                                                isMobile ? /*#__PURE__*/ _jsx("br", {}) : " ",
                                                                                visits.vs_visit_visitdate != "" && visits.vs_visit_visitdate != null && visits.vs_visit_visitdate != undefined ? moment.parseZone(visits.vs_visit_visitdate).format("D MMMM YYYY HH:mm") : "-"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            });
                                        })
                                    ]
                                });
                            }),
                            !visitLists || visitLists.length == 0 && /*#__PURE__*/ _jsx(_Fragment, {
                                children: /*#__PURE__*/ _jsx("h5", {
                                    className: "h5 mb-2 text-center",
                                    children: "ไม่มีรายการเยี่ยมร้านค้า"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
